import type {
  GatewayModelTypesResponse,
  GatewayShipmentReasonsResponse,
  GatewayShipmentRequestHistoryResponse,
} from "@/.generated/hey/backoffice-backend/types.gen";
import type {
  GatewayShipmentModelTypeModel,
  GatewayShipmentReasonModel,
  GatewayShipmentRequestHistoryModel,
} from "@/domains/gateway-shipment/gateway-shipment.types";

import { brandNumber } from "@/lib/branded";

export function mapGatewayShipmentReasonsResponse(
  response: GatewayShipmentReasonsResponse,
): Array<GatewayShipmentReasonModel> {
  return response.reasons.map((reason) => ({
    id: brandNumber(reason.id),
    note: reason.note,
  }));
}

export function mapGatewayShipmentModelTypesResponse(
  response: GatewayModelTypesResponse,
): Array<GatewayShipmentModelTypeModel> {
  return response.modelTypes.map((modelType) => ({
    id: brandNumber(modelType.id),
    note: modelType.note,
  }));
}

export function mapGatewayShipmentRequestHistoryResponse(
  response: GatewayShipmentRequestHistoryResponse,
): Array<GatewayShipmentRequestHistoryModel> {
  return response.requests.map((request) => ({
    id: brandNumber(request.id),
    gatewayModelId: brandNumber(request.gatewayModelId),
    shipmentReasonId: brandNumber(request.shipmentReasonId),
    comment: request.comment,
    instant: new Date(request.instant),
    operatorCreationId: brandNumber(request.operatorCreationId),
  }));
}
